<template>
  <div class="view pa24">
    <div class="d-flex align-items-center">
      状态：
      <div v-for="(item,index) in dateList"
           @click="currentDateIndex = item.date"
           :key="index"
           class="flex-c-c w80 h34 mr10 br5 hover_pointer"
           :class=" currentDateIndex == item.date ?  'bbule1 cblue trans2' : 'bDCDFE6 trans2' ">
          {{item.name}}
      </div>
      
      <el-date-picker
        v-model="pickerValue"
        class="mr10 "
        align="right"
        value-format="yyyy-MM-dd"
        type="daterange"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      />
      <el-button type="primary" @click="queryBossWithdrawals">搜索</el-button>
    </div>
    
    <commonTable
      :tableData="tableData"
      :loading="loading"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      :currentPage="currentPage"
      :total="total"
    >
      <template v-slot:table>
        <el-table-column
            prop="createdTime"
            align="center"
            label="申请时间"
            show-overflow-tooltip
          />
        <el-table-column prop="amount" align="center" label="申请金额"/>
        <el-table-column prop="balance" align="center" label="可提现金额" />
        <el-table-column prop="name" align="center" label="提现账户"/>
        <el-table-column prop="note" align="center" label="备注描述" />
        <el-table-column prop="approvalTime" align="center" label="打款时间" />
        <el-table-column prop="forwardfNum" align="center" label="状态">
            <template slot-scope="scope">
              <div class="cblue">
                <p class="cblue" v-if="scope.row.approvalStatus == 0">等待打款</p>
                <p class="cblue" v-if="scope.row.approvalStatus == 1">打款成功</p>
                <p class="corange" v-if="scope.row.approvalStatus == 2">已驳回</p>
                <p class="cblue" v-if="scope.row.approvalStatus == 3">审核通过待打款</p>
              </div>
            </template>
          </el-table-column>
      </template>
    </commonTable>

  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import { getDataTimeSec } from "@/utils";
import {  queryOrders,querySells,addBossWithdrawals,queryBossWithdrawals } from "@/api/financing";
export default {
  name: "visitorData",
  components: {
    commonTable,
  },
  data() {
    return {
      pickerValue: "", //选择时间
      tableData: [],
      currentPage: 1, //当前页
      pageSize: 10, //显示条数
      loading: false, //表格加载
      total: 0, //总条数
      staffs: [],
      userId: "",
      sourcesId: "",
      dateList: [
        { id: 1, name: "全部" ,date:4 },
        { id: 2, name: "等待打款" ,date:0},
        { id: 3, name: "打款成功" ,date: 1},
        { id: 4, name: "已驳回" ,date: 2},
      ],
      authsId: "",
      phone: "",
      currentDateIndex:4,
      dialogTableVisible:false,
    };
  },
  filters: {
    getDataTimeSec(val) {
      return getDataTimeSec(val);
    },
  },
  created() {
    this.queryBossWithdrawals();
  },
  methods: {
    async queryBossWithdrawals() {
      let data = {
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        approvalStatus:this.currentDateIndex,
        startTime: this.pickerValue && `${this.pickerValue[0]} 00:00:00`,
        endTime: this.pickerValue && `${this.pickerValue[1]} 23:59:59`,
      };
      if(this.currentDateIndex == 4){
        data.approvalStatus = ''
      }
      try {
        this.loading = true;
        const result = await queryBossWithdrawals(data);
        this.loading = false;
        const { total, list } = result?.data.pageInfo;
        this.tableData = list;
        this.tableData.forEach(item=>{

        })
        this.total = total;
      } catch (error) {
        this.tableData = []
        this.loading = false;
        console.log(error);
      }
    },
    formatSeconds(value) {
      var theTime = parseInt(value);// 秒
      var theTime1 = 0;// 分
      var theTime2 = 0;// 小时
      if(theTime > 60) {
        theTime1 = parseInt(theTime/60);
        theTime = parseInt(theTime%60);
        if(theTime1 > 60) {
          theTime2 = parseInt(theTime1/60);
          theTime1 = parseInt(theTime1%60);
        }
      }
      var result = ""+parseInt(theTime)+"秒";
      if(theTime1 > 0) {
        result = ""+parseInt(theTime1)+"分"+result;
      }
      if(theTime2 > 0) {
        result = ""+parseInt(theTime2)+"小时"+result;
      }
      return result;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryBossWithdrawals();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryBossWithdrawals();
    },
    dialogClose(){
      this.dialogTableVisible = false
    },
    
  },
};
</script>

<style lang="scss" scoped>
</style>